module.exports = __webpack_public_path__ + "img/team-feature.0dc3cc5b.png";